// Pattern: docs/design-patterns/frontend/component-patterns.md (display component)
// Pattern: docs/design-patterns/frontend/accessibility.md (ARIA landmarks, keyboard nav)
// Pattern: docs/design-patterns/frontend/design-system-consistency.md (design tokens)

import type { JSX } from 'react';
import { NavLink } from 'react-router-dom';
import { KeyRound, Mail, Puzzle, Shield, User } from 'lucide-react';

interface NavItem {
  to: string;
  label: string;
  icon: JSX.Element;
}

const NAV_ITEMS: NavItem[] = [
  { to: '/settings/profile', label: 'Profile', icon: <User className="w-4 h-4" /> },
  { to: '/settings/security', label: 'Security', icon: <Shield className="w-4 h-4" /> },
  { to: '/settings/integrations', label: 'Integrations', icon: <Puzzle className="w-4 h-4" /> },
  { to: '/settings/tokens', label: 'Tokens', icon: <KeyRound className="w-4 h-4" /> },
  { to: '/settings/invitations', label: 'Invitations', icon: <Mail className="w-4 h-4" /> },
];

interface SettingsSidebarProps {
  onNavigate?: () => void;
}

export function SettingsSidebar({ onNavigate }: SettingsSidebarProps): JSX.Element {
  return (
    <nav aria-label="Settings" className="flex flex-col">
      <h2 className="px-4 pt-4 pb-2 text-xs font-semibold uppercase tracking-wider text-muted">
        Settings
      </h2>
      {NAV_ITEMS.map(({ icon, label, to }) => (
        <NavLink
          key={to}
          to={to}
          onClick={onNavigate}
          className={({ isActive }) =>
            `flex items-center gap-3 px-4 py-2.5 text-sm transition-colors border-l-2 ${
              isActive
                ? 'border-primary text-foreground font-semibold'
                : 'border-transparent text-foreground/60 hover:text-foreground hover:bg-surface'
            }`
          }
        >
          {icon}
          {label}
        </NavLink>
      ))}
    </nav>
  );
}
